module.exports = __webpack_public_path__ + "static/product-pc-content-4-0fdeebf5917a42eaa4c441948ad3602c.jpg";